import {
  fixNormalisedNodeFields,
  fixNormalisedNodeValues,
} from '@modules/queryBuilder/helpers';
import { QueryBuilderActionType } from '@modules/queryBuilder/store/queryBuilderActionType';
import { useQueryBuilderStore } from '@modules/queryBuilder/store/useQueryBuilderStore';
import { useCallback, useEffect } from 'react';
import { useFromWhereClause } from 'v2/core/services/queryBuilder/useFromWhereClause';
import {
  EmptyWhereClause,
  WhereClause,
} from 'v2/core/services/queryBuilder/whereClause';
import normaliseQuery from 'v2/querybuilder/services/denormalise/normaliseQuery';

export function useResetQuery(whereClauseProp: WhereClause) {
  const fromWhereClause = useFromWhereClause();
  const dispatch = useQueryBuilderStore(({ dispatch }) => dispatch);

  const resetQuery = useCallback(
    (whereClause?: WhereClause) => {
      const nodes = normaliseQuery(
        fromWhereClause(whereClause ?? EmptyWhereClause),
      );

      // Workaround to fix incorrect value foramt
      fixNormalisedNodeFields(nodes);
      fixNormalisedNodeValues(nodes);

      dispatch({
        type: QueryBuilderActionType.SET_QUERY,
        payload: {
          nodes,
        },
      });

      dispatch({
        type: QueryBuilderActionType.SET_METADATA,
        payload: {
          hasUnsavedChanges: false,
        },
      });
    },
    [dispatch, fromWhereClause],
  );

  useEffect(() => {
    resetQuery(whereClauseProp);
  }, [whereClauseProp, resetQuery]);

  return resetQuery;
}
